import { Action } from 'redux';
import { OrderedSet, OrderedMap } from 'immutable';

import {
    GET_FILTERS_REQUEST,
    GET_FILTERS_RESPONSE,
    GET_FILTERS_ERROR,

    RESET_FILTERS,

    SET_AGE,
    SET_CATEGORIES,
    SET_GENRES,
    SET_ORDER
} from '../../actions/Afisha/filters';

import { Category } from '../../models/Afisha/Category';
import Genre from '../../models/Afisha/Genre';

export interface FiltersAfishaState {
    order: string;
    ageRestriction: number | null;
    genres: OrderedMap<number, Genre>;

    orderFilters: OrderedSet<string>;
    ageRestrictionFilters: OrderedSet<number>;
    genresFilters: OrderedMap<number, Genre>;

    categories: OrderedMap<string, Category>;
    categoriesFilters: OrderedMap<string, Category>;
    loadingFilters: boolean;
    errorFilters: any;
}

const initialState: FiltersAfishaState = {
    order: 'view_count_daily',
    ageRestriction: null,
    genres: OrderedMap<number, Genre>(),

    orderFilters: OrderedSet<string>(['rating', 'view_count_daily', 'release_date']),
    ageRestrictionFilters: OrderedSet<number>(),
    genresFilters: OrderedMap<number, Genre>(),

    categories: OrderedMap<string, Category>(),
    categoriesFilters: OrderedMap<string, Category>(),
    loadingFilters: false,
    errorFilters: null
};

export function filtersAfisha(state: FiltersAfishaState = initialState, action: Action) {
    switch (action.type) {
        case GET_FILTERS_REQUEST: {
            return {
                ...state,
                loadingEvents: true,
                errorFilters: initialState.errorFilters,
                ageRestrictionFilters: initialState.ageRestrictionFilters,
                genresFilters: initialState.genresFilters,
                categoriesFilters: initialState.categoriesFilters
            };
        }
        case GET_FILTERS_RESPONSE: {
            const resp = (action as any).response;
            const type = (action as any).typeFilters;
            if (type === 'places') {
                const result: Category[] = resp.result;
                return {
                    ...state,
                    loadingEvents: false,
                    categoriesFilters: result,
                };
            }
            return {
                ...state,
                loadingEvents: false,
                ageRestrictionFilters: resp.result.age_restrictions,
                genresFilters: resp.result.genres
            };
        }
        case GET_FILTERS_ERROR: {
            const errorFilters = (action as any).error;
            return {
                ...state,
                loadingFilters: false,
                errorFilters
            };
        }

        case RESET_FILTERS: {
            return {
                ...state,
                ageRestriction: initialState.ageRestriction,
                genres: initialState.genres,
                order: initialState.order,
                categories: initialState.categories
            };
        }

        case SET_ORDER: {
            const order = (action as any).order;
            return {
                ...state,
                order
            };
        }
        case SET_GENRES: {
            const genres = (action as any).genres;
            return {
                ...state,
                genres
            };
        }
        case SET_CATEGORIES: {
            const categories = (action as any).categories;
            return {
                ...state,
                categories
            };
        }
        case SET_AGE: {
            const ageRestriction = (action as any).ageRestriction;
            return {
                ...state,
                ageRestriction
            };
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/reducers/Afisha/filters.ts